import SliderBanner from './SliderBanner.jsx';
export default SliderBanner;



// WEBPACK FOOTER //
// ./src/components/slider-banner/index.js